import React, { memo, useContext } from "react"
import VerticalLayout from "../VerticalLayout/index"
import TableList from "../TableList/TableListOrders"
import { OrderListContext } from "./OrderListContext"
import PaginationComponent from "../Pagination"

/**
 * Based on the orders, the table here gets populated. The data for the table given by hooks wrapper.
 * @returns {Object}
 */
const OrderList = () => {
  const OrderListModel = useContext(OrderListContext)
  const {
    jobTableTitle,
    jobOrderData,
    nextPage,
    totalPagesCount,
    pageNumberThreshold,
    orderType,
    setOrderType,
  } = OrderListModel

  return (
    <VerticalLayout>
      <div className="mt-5">
        {/**
         * The table list will show the ui for the orders that made by users
         * @param {Array} titleList
         * @param {Array} tableData
         */}
        {/* <PaginationComponent /> */}
        <TableList
          title={"Orders List"}
          titleList={jobTableTitle?.titles}
          tableData={jobOrderData}
          nextPage={nextPage}
          totalPagesCount={totalPagesCount}
          pageNumberThreshold={pageNumberThreshold}
          orderType={orderType}
          setOrderType={setOrderType}
        />
      </div>
    </VerticalLayout>
  )
}

export default OrderList
